var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-card',{staticClass:"custom-shadow"},[_c('q-card-section',[_vm._l((_vm.defaultPosition),function(blockId,index){return _c('Block',_vm._b({key:index,attrs:{"data":blockId,"colIndex":"0","index":index}},'Block',_vm.$props,false))}),_c('AddBlockButton',{attrs:{"parent":_vm.data.id,"index":_vm.defaultPosition.length}})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }